export function guruName(guru) {
  return (
    guru.name ||
    [guru.first_name, guru.last_name].filter(Boolean).join(" ") ||
    guru.email ||
    `Guru #${guru.guru_id || guru.id}`
  );
}

export function availableGuruOptions(allGurus = [], memberships = []) {
  const activeIds = new Set(
    memberships
      .filter((membership) => membership.membership_status === "ACTIVE")
      .map((membership) => Number(membership.guru_id))
  );
  const membershipByGuru = new Map(
    memberships.map((membership) => [Number(membership.guru_id), membership])
  );

  return allGurus
    .filter((guru) => !activeIds.has(Number(guru.id)))
    .map((guru) => ({
      ...guru,
      label: guruName(guru),
      action:
        membershipByGuru.get(Number(guru.id))?.membership_status === "INACTIVE"
          ? "Reactivate"
          : "Add",
    }))
    .sort((left, right) => left.label.localeCompare(right.label));
}
